import type { IconProps } from './icons';
import { createSvgIcon } from './icons';

export default function ChevronLeftIcon(props: IconProps) {
    const svg = <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 -960 960 960" width="100%" fill="#currentColor">
                    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                </svg>
    return (
        createSvgIcon(svg, props)
    );
}
